import React from "react";
import {Routes, Route, useLocation} from "react-router-dom";
import {ApolloProvider} from "@apollo/client";
import {apolloClient} from "./routes/helpers/apolloClient";
import ClientesRoutes from "./routes/ClientesRoutes";
import PolkistasRoutes from "./routes/PolkistasRoutes";
import GenericDataContextProvider from "./context/GenericDataContext/GenericDataContextProvider";
import GoogleTagManager from "./components/Analytics/GoogleTagManager/GoogleTagManager";
import {GTM_IDS} from "./components/Analytics/GoogleTagManager/constats";

function isValidBase64(str) {
    return /^[A-Za-z0-9+/=]+$/.test(str) && str.length % 4 === 0;
}

function App() {
    const location = useLocation();
    const urlPieces = location.pathname.split('/');

    let idPaginaPolkista = null;
    let idPolkista = null;

    for (let urlPiece of urlPieces) {
        const splitUrl = urlPiece.split('?')[0];
        if (isValidBase64(splitUrl)) {
            const decoded = atob(splitUrl).split(':');
            if (decoded.length === 2) {
                [idPaginaPolkista, idPolkista] = decoded;
                break;
            }
        }
    }

    const gtmId = !idPaginaPolkista ? GTM_IDS.CLIENTES : GTM_IDS.POLKISTAS;

    return (
        <GenericDataContextProvider idPaginaPolkista={idPaginaPolkista} idPolkista={idPolkista}>
            <GoogleTagManager gtmId={gtmId} />
            <Routes>
                {!idPaginaPolkista ? (
                    <Route
                        path="/*"
                        element={<ClientesRoutes/>}
                    />
                ) : (
                    <Route
                        path=":encodedId/*"
                        element={
                            <ApolloProvider client={apolloClient}>
                                <PolkistasRoutes/>
                            </ApolloProvider>
                        }
                    />
                )}
            </Routes>
        </GenericDataContextProvider>
    );
}

export default App;
